import { useEffect } from "react";
import { useLayout } from "../../context/LayoutContext";
import { navRailWidth } from "../../components/layout/navRail";

/**
 * Null-rendering bridge: the toast container (mounted above LayoutProvider)
 * can't read the sidebar state, so this component -- mounted inside
 * MainComponent -- writes the horizontal shift that keeps toasts centered
 * over the content area as a CSS custom property (see index.css).
 *
 * The widths come from navRail rather than being restated here. The carried-over
 * version had its own 240/72 pair plus xxl and uhd variants, none of which this
 * app's rail implements -- it is a flat 232/64 at every breakpoint -- and it
 * gated the shift on `lg` and up, where ReportGen hid its drawer on smaller
 * screens. This rail is always rendered, so the shift always applies.
 */
export function ToastOffsetSync(): null {
  const { sidebarOpen } = useLayout();

  useEffect(() => {
    const width = navRailWidth(sidebarOpen);
    document.documentElement.style.setProperty(
      "--karda-toast-shift",
      `${width / 2}px`,
    );
    return () => {
      document.documentElement.style.removeProperty("--karda-toast-shift");
    };
  }, [sidebarOpen]);

  return null;
}
